module.exports = __webpack_public_path__ + "src/img/product_pic.jpg?2d4b5cce6eea820ab5d1467ff7954137";


//////////////////
// WEBPACK FOOTER
// ./src/img/product_pic.jpg
// module id = 196
// module chunks = 0